import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
    resetPassword as resetPasswordAction,
    setPassword as setPasswordAction,
} from '../../actions/auth';

import SetPasswordPage from './SetPasswordPage';

const _mapStateToProps = (state) => ({
    locale: state.authentication.locale,
});

const _mapDispatchToProps = {
    handleResetPassword: resetPasswordAction,
    handleSetPassword: setPasswordAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(SetPasswordPage),
);
